import React from 'react'
import PropTypes from 'prop-types'

export interface OverallRatingProps {
  ratingLabel: string // This should be stricter, but requires refactoring Const.RATING_TYPES
  value: number
}

export const OverallRating = ({ ratingLabel, value }: OverallRatingProps): React.ReactElement => {
  const displayRatingValue = Math.round(value) / 10

  const ratingLabelDisplay = `${ratingLabel} Rating`

  return (
    <div className='overall-rating-box'>
      <div className='color-pro-steel-grey-600 font-bold pro-text-xs'>{ratingLabelDisplay}</div>
      <div className='star-rating-container overall-rating'>
        <div className={`star-rating stars-${value}`} />
      </div>
      <div>
        <span className='bold pro-text-s'>{displayRatingValue} out of 5</span>
      </div>
    </div>
  )
}

OverallRating.propTypes = {
  ratingLabel: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired
}
